import { Controller, SubmitHandler, useFormContext } from 'react-hook-form';
import { PrimaryButton, PrimaryTextField, ErrorMessage } from 'components';
import { IResetPasswordForm } from 'base/auth/interface';

interface Props {
  onSubmit: SubmitHandler<any>;
}

const ResetPasswordFormView = (props: Props) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<IResetPasswordForm>();
  const { onSubmit } = props;
  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ textAlign: 'left' }}>
      <div className="hiddenInput">
        <Controller
          control={control}
          name="verificationCode"
          render={({ field }) => <PrimaryTextField disabled {...field} type="hidden" />}
        />
        <ErrorMessage>{errors?.verificationCode?.message}</ErrorMessage>
      </div>
      <div className="hiddenInput">
        <Controller
          control={control}
          name="name"
          render={({ field }) => <PrimaryTextField disabled {...field} type="hidden" />}
        />
        <ErrorMessage>{errors?.name?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <Controller
          control={control}
          name="newPassword"
          render={({ field }) => <PrimaryTextField {...field} label="New password" isPassword />}
        />
        <ErrorMessage>{errors?.newPassword?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <Controller
          control={control}
          name="confirmPassword"
          render={({ field }) => (
            <PrimaryTextField {...field} label="Confirm password" isPassword />
          )}
        />
        <ErrorMessage>{errors?.confirmPassword?.message}</ErrorMessage>
      </div>
      <div className="form-item">
        <PrimaryButton size="large" fullWidth type="submit">
          Save new password
        </PrimaryButton>
      </div>
    </form>
  );
};

export default ResetPasswordFormView;
